<app-specific-questionnaire
  [title]="'TGA.Questionnaire.SoilQuestions.label' | translate"
  [questions]="soilQuestions()"
  [formStateUpdater]="updateFormState"
  (answersUpdated)="answersUpdated($event)"
  [readOnly]="isCropYearReadOnly()"
  [cropField]="cropField()"
  [cropYear]="cropYear()"
></app-specific-questionnaire>
